export const COLOR_GRAY = "#aaa";
export const COLOR_GRAY_STYLE = { color: COLOR_GRAY };

export const ACUMIN = {
  fontFamily: '"acumin-pro-extra-condensed",sans-serif',
};
export const ACUMIN_CONDENSED = {
  fontFamily: '"acumin-pro-condensed",sans-serif',
};

export const LINK_SIZE = {
  fontSize: 40,
};

export const COLOR_GREEN = "#699132";
export const COLOR_GREEN_STYLE = { color: COLOR_GREEN };

export const LINK_STYLE = Object.assign({ fontWeight: 200 }, COLOR_GREEN_STYLE, ACUMIN, LINK_SIZE);
export const GRAY_LINK_STYLE = Object.assign(
  { fontWeight: 200 },
  COLOR_GRAY_STYLE,
  ACUMIN,
  LINK_SIZE,
);

export const GRASS_BODY = { width: 725, margin: "50px auto" };

export const FONT_LEAGUE = {
  fontFamily: '"league-gothic",sans-serif',
};
export const FONT_THIN = {
  fontFamily: '"acumin-pro-extra-condensed",sans-serif',
  fontWeight: 64,
};



// WEBPACK FOOTER //
// ./src/styles.js